import React from 'react';
import { Row, Col } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { SearchForm } from './../../components';
import { getUser } from '../../selectors/Authentication';
import {
  getAddressSuggestions,
  getUnpaidFees,
  getSearchActionResponse,
} from '../../selectors/Search';
import { opslag, dawaLookup } from '../../actions/Search';
import { getAllUsers } from '../../actions/User';
import { getUserRoles } from '../../actions/Authentication';
import { getAllCompanies } from '../../actions/Company';
import { clearActionResponse } from './../../actions/Global';

class Search extends React.Component {
  render() {
    return (
      <Row type={'flex'} align={'middle'}>
        <Col span={24}>
          <SearchForm
            unpaidFees={this.props.unpaidFees}
            opslag={this.props.opslag}
            dawaLookup={this.props.dawaLookup}
            addressSuggestions={this.props.addressSuggestions}
            actionResponse={this.props.searchActionResponse}
            clearActionResponse={this.props.clearActionResponse}
          />
        </Col>
      </Row>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{user, unpaidFees, addressSuggestions, searchActionResponse}}
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    unpaidFees: getUnpaidFees(state),
    addressSuggestions: getAddressSuggestions(state),
    searchActionResponse: getSearchActionResponse(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{opslag: opslag, dawaLookup: dawaLookup, getAllUsers: getAllUsers, getUserRoles: getUserRoles,
 * getAllCompanies: getAllCompanies, clearActionResponse: clearActionResponse}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      opslag: opslag,
      dawaLookup: dawaLookup,
      getAllUsers: getAllUsers,
      getUserRoles: getUserRoles,
      getAllCompanies: getAllCompanies,
      clearActionResponse: clearActionResponse,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{user: shim, unpaidFees: shim, addressSuggestions: shim, actionResponse: shim, opslag: shim,
 * dawaLookup: shim, getAllUsers: shim, getUserRoles: shim, getAllCompanies: shim, clearActionResponse: shim}}
 */
Search.propTypes = {
  user: PropTypes.instanceOf(Map),
  unpaidFees: PropTypes.instanceOf(List),
  addressSuggestions: PropTypes.instanceOf(List),
  actionResponse: PropTypes.instanceOf(Map),
  opslag: PropTypes.func,
  dawaLookup: PropTypes.func,
  getAllUsers: PropTypes.func,
  getUserRoles: PropTypes.func,
  getAllCompanies: PropTypes.func,
  clearActionResponse: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
